// WorkspaceList.jsx

import React from 'react';

// CSS
import './WorkspaceList.css';

// Components
import AddWorkspaceButton from 'main/sidebar/switcher/popup/addworkspace/AddWorkspaceButton';
import Divider from 'components/divider/Divider';
import WorkspaceButton from 'main/sidebar/switcher/popup/workspacelist/button/WorkspaceButton';

/**
 * WorkspaceList
 * 
 * Renders the list of workspaces in the sidebar switcher popup.
 *  
 * @returns {ReactNode} - WorkspaceList.
 */
const WorkspaceList = React.memo(({
    onSelect,
    onAdd,
    onPublishTemplate,
    canPublishTemplate = false,
    workspaces = [],
    activeWorkspaceKey = null,
}) => {

    const getWorkspaceKey = (workspace) => {
        const key = String(workspace?.key || '').trim();
        if (key) return key;
        return String(workspace?.id || '').trim();
    };

    return (

        <div className="workspace-list-container">

            {/* SPACES LIST */}
            <div className="workspace-list-buttons">

                {workspaces.map((workspace) => (
                    <WorkspaceButton
                        key={getWorkspaceKey(workspace) || String(workspace?.title || '')}
                        workspace={workspace}
                        isActive={Boolean(activeWorkspaceKey && (getWorkspaceKey(workspace) === activeWorkspaceKey))}
                        onClick={() => onSelect(workspace)}
                    />
                ))}

            </div>

            <Divider />

            {/* ADD SPACE */}
            <AddWorkspaceButton
                onClick={onAdd}
            />

            <Divider />

            {canPublishTemplate && (
                <AddWorkspaceButton
                    onClick={onPublishTemplate}
                    label="Publish Template"
                    iconKey="upload"
                />
            )}

        </div>
    );

});

// Dev Tools
WorkspaceList.displayName = 'WorkspaceList';

export default WorkspaceList;

